/* ZCT_V26_MENUE: Ausklapper der Leiste, Markup in snippets/zct-v26-desktop-menue.liquid.
   Ab 1024 px Mega-Menü unter der Desktop-Leiste; bis 1023 px öffnet ein Punkt der Handy-Leiste stattdessen das Stufen-Menü
   (zct-kopfleiste, .overlay-menu) gleich auf der passenden Stufe.
   - Maus: Überfahren öffnet nach kurzer Absicht (70 ms), Verlassen schließt nach 180 ms; Wechsel zwischen offenen Ausklappern nach 90 ms.
   - Klick und Tastatur: Knopf schaltet um (aria-expanded), Escape schließt und gibt den Fokus zurück, Fokus außerhalb schließt.
   - In jedem Ausklapper schaltet Spalte 1 (data-zd-tab) Auswahl und Bild um (data-zd-tabinhalt): Überfahren, Fokus oder Klick.
   - Bilder laden erst beim ersten Öffnen (data-zd-src). Die Ebene sitzt direkt unter der Leiste (auch wenn die Ankündigung weggescrollt ist).
   Bewegung im CSS (zct-v26.css, Abschnitt 4): Einblenden --zd-dauer-menue, Ausblenden --zd-dauer-menue-zu, bei reduzierter Bewegung nur Deckkraft.
   Ankündigung, Leiste und Ausklapper liegen auf einer gemeinsamen Glasfläche (.zd-glas), der Schleier beginnt darunter; beide folgen
   der Höhe des offenen Ausklappers (flaeche), beim Wechsel wächst oder schrumpft die Fläche weich (hoeheWechsel). */
(function () {
  'use strict';
  // Bewegung komplett: Zeit-Token lesen; Shopify liefert das CSS verkleinert aus (200ms wird .2s), daher Sekunden und Millisekunden
  function zdZeit(v) { v = String(v || '').trim(); var x = parseFloat(v); if (isNaN(x)) return NaN; return /ms$/i.test(v) ? x : (/s$/i.test(v) ? x * 1000 : x); }
  var MQ = window.matchMedia('(min-width: 1024px)');
  var feinerZeiger = window.matchMedia('(hover: hover) and (pointer: fine)');
  var wenigBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');

  function start() {
    var kopf = document.querySelector('zct-kopf');
    var ebene = kopf && kopf.querySelector('[data-zd-ebene]');
    var nav = kopf && kopf.querySelector('nav.nav');
    if (!ebene || !nav) return;
    var knoepfe = Array.prototype.slice.call(kopf.querySelectorAll('[data-zd-auf]'));
    var panels = {};
    ebene.querySelectorAll('[data-zd-panel]').forEach(function (p) { panels[p.getAttribute('data-zd-panel')] = p; });
    var offen = null, uhrAuf = 0, uhrZu = 0, uhrWeg = 0, perHover = 0, glasLauf = null;
    var glas = ebene.querySelector('.zd-glas'), schleier = ebene.querySelector('.zd-schleier');

    function obenPx() { return parseFloat(ebene.style.getPropertyValue('--zd-oben')) || 0; }
    function oben() {
      var b = nav.getBoundingClientRect().bottom;
      ebene.style.setProperty('--zd-oben', Math.max(0, Math.round(b)) + 'px');
      flaeche();
    }
    // Glasfläche (von ganz oben bis zur Unterkante des offenen Ausklappers) und Schleier (darunter) direkt am Element setzen, nicht über eine
    // Variable am Elternteil (die rechnet alle Kinder neu). Während eines Wechsels hält hoeheWechsel die Höhe.
    function flaeche() {
      if (!offen) return;
      var h = panels[offen].offsetHeight, o = obenPx();
      if (schleier) schleier.style.transform = 'translateY(' + h + 'px)';
      if (glas) { glas.style.top = -o + 'px'; if (!glasLauf) glas.style.height = (o + h) + 'px'; }
    }
    if (window.ResizeObserver) { var ro = new ResizeObserver(flaeche); Object.keys(panels).forEach(function (k) { ro.observe(panels[k]); }); }
    // Sichtbare Höhe der Glasfläche unter der Leiste, auch mitten in einem Wechsel (berechneter Clip-Pfad)
    function glasHoehe() {
      var r = glas.getBoundingClientRect().height - obenPx();
      var m = /inset\(([^)]*)\)/.exec(getComputedStyle(glas).clipPath || '');
      if (m) { var w = m[1].trim().split(/\s+/).map(parseFloat); r -= (w.length > 2 ? w[2] : w[0]) || 0; }
      return r;
    }
    var schleierLauf = null;
    function glasStopp() {
      if (schleierLauf) { schleierLauf.cancel(); schleierLauf = null; }
      if (glasLauf) { var g = glasLauf; glasLauf = null; g.onfinish = null; g.cancel(); }
    }
    function bilder(p) {
      p.querySelectorAll('img[data-zd-src]').forEach(function (img) {
        if (img.getAttribute('data-zd-srcset')) img.setAttribute('srcset', img.getAttribute('data-zd-srcset'));
        img.setAttribute('src', img.getAttribute('data-zd-src'));
        img.removeAttribute('data-zd-src');
      });
    }
    // Wechsel zu einem anders hohen Ausklapper: die Glasfläche wächst oder schrumpft von der sichtbaren auf die neue Höhe (Clip-Pfad statt
    // Höhe, damit nichts neu umbricht). Schleier und, wenn es größer wird, der neue Inhalt laufen als Animationen aus demselben Aufruf mit,
    // damit sie im selben Bild starten (ein CSS-Übergang lief dem Glas bis zu zwei Bilder voraus, dazwischen blitzte ein Streifen auf).
    function hoeheWechsel(neu, hVon) {
      glasStopp();
      if (wenigBewegung.matches || !glas || !glas.animate) return;
      var hNeu = neu.offsetHeight, d = hNeu - hVon;
      if (Math.abs(d) < 2) return;
      var css = getComputedStyle(document.documentElement);
      var opt = { duration: zdZeit(css.getPropertyValue('--zd-dauer-menue')) || 250, easing: css.getPropertyValue('--zd-kurve-aus').trim() || 'ease-out' };
      var hoch = Math.max(hVon, hNeu);
      glas.style.height = (obenPx() + hoch) + 'px';
      var lauf = glasLauf = glas.animate([{ clipPath: 'inset(0 0 ' + (hoch - hVon) + 'px 0)' }, { clipPath: 'inset(0 0 ' + (hoch - hNeu) + 'px 0)' }], opt);
      if (schleier) schleierLauf = schleier.animate([{ transform: 'translateY(' + hVon + 'px)' }, { transform: 'translateY(' + hNeu + 'px)' }], opt);
      lauf.onfinish = function () { if (glasLauf === lauf) { glasLauf = null; flaeche(); } };
      if (d > 0) neu.animate([{ clipPath: 'inset(0 0 ' + d + 'px 0)' }, { clipPath: 'inset(0 0 0 0)' }], opt);
    }
    function auf(name) {
      if (!panels[name]) return;
      clearTimeout(uhrZu); clearTimeout(uhrWeg);
      var war = offen;
      var hVon = war && war !== name && glas ? glasHoehe() : 0;
      oben();
      offen = name;
      Object.keys(panels).forEach(function (k) { panels[k].hidden = k !== name; });
      knoepfe.forEach(function (k) { k.setAttribute('aria-expanded', String(k.getAttribute('data-zd-auf') === name)); });
      bilder(panels[name]);
      if (!war) {
        glasStopp();
        ebene.hidden = false;
        flaeche();
        ebene.getBoundingClientRect();
        ebene.classList.add('is-offen');
      } else if (war !== name) { hoeheWechsel(panels[name], hVon); flaeche(); }
      document.documentElement.classList.add('zd-menue-offen');
    }
    function zu(fokusZurueck) {
      clearTimeout(uhrAuf); clearTimeout(uhrZu);
      if (!offen) return;
      var knopf = kopf.querySelector('[data-zd-auf="' + offen + '"]');
      offen = null;
      knoepfe.forEach(function (k) { k.setAttribute('aria-expanded', 'false'); });
      glasStopp();
      ebene.classList.remove('is-offen');
      document.documentElement.classList.remove('zd-menue-offen');
      uhrWeg = setTimeout(function () { if (!offen) { ebene.hidden = true; Object.keys(panels).forEach(function (k) { panels[k].hidden = true; }); } }, (zdZeit(getComputedStyle(document.documentElement).getPropertyValue('--zd-dauer-menue-zu')) || 200) + 20);
      if (fokusZurueck && knopf) knopf.focus({ preventScroll: true });
    }
    // Handy: Punkt der Leiste öffnet das Stufen-Menü auf seiner Stufe (Knöpfe der ersten Stufe in zct-kopfleiste)
    var STUFE = { produkte: '.om-link-cats', kollektionen: '.om-link-cols', raeume: '.om-link-raeume', behind: '.om-link-behind' };
    function handyStufe(name) {
      var menueKnopf = nav.querySelector('.nav-menu-btn'), om = kopf.querySelector('.overlay-menu');
      var ziel = om && STUFE[name] && om.querySelector(STUFE[name]);
      if (!menueKnopf || !ziel) return;
      if (!om.classList.contains('open')) menueKnopf.click();
      ziel.click();
    }
    function spaeterZu() { clearTimeout(uhrAuf); clearTimeout(uhrZu); uhrZu = setTimeout(function () { zu(false); }, 180); }

    knoepfe.forEach(function (k) {
      var name = k.getAttribute('data-zd-auf');
      k.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !feinerZeiger.matches) return;
        clearTimeout(uhrZu); clearTimeout(uhrAuf);
        // Bei offenem Ausklapper erst nach kurzer Absicht wechseln: wer schräg zur Spalte 1 fährt, streift sonst einen Nachbarpunkt
        if (offen) { uhrAuf = setTimeout(function () { auf(name); perHover = Date.now(); }, 90); return; }
        uhrAuf = setTimeout(function () { auf(name); perHover = Date.now(); }, 70);
      });
      k.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') spaeterZu(); });
      k.addEventListener('click', function () {
        if (!MQ.matches) { handyStufe(name); return; }
        // Wer gerade per Überfahren geöffnet hat und dann klickt, will offen lassen
        if (offen === name && Date.now() - perHover < 400) return;
        if (offen === name) zu(false); else auf(name);
      });
      k.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && offen !== name) { e.preventDefault(); auf(name); var erstes = panels[name].querySelector('a[href],button'); if (erstes) erstes.focus(); }
      });
    });
    // Andere Menüpunkte (Bestseller, Über uns …) schließen beim Überfahren sofort
    kopf.querySelectorAll('.zd-leiste a.zd-punkt:not([data-zd-auf])').forEach(function (a) {
      a.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && offen) zu(false); });
    });
    Object.keys(panels).forEach(function (k) {
      panels[k].addEventListener('pointerenter', function () { clearTimeout(uhrZu); });
      panels[k].addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') spaeterZu(); });
    });
    ebene.querySelector('[data-zd-zu]').addEventListener('click', function () { zu(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && offen) zu(ebene.contains(document.activeElement) || kopf.querySelector('.zd-leiste').contains(document.activeElement)); });
    kopf.addEventListener('focusout', function (e) {
      if (!offen) return;
      var nach = e.relatedTarget;
      if (nach && (ebene.contains(nach) || kopf.querySelector('.zd-leiste').contains(nach))) return;
      if (nach) zu(false);
    });
    // Suche öffnet über der Seite: Ausklapper vorher schließen
    kopf.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-zct-suche-auf]')) zu(false); });
    window.addEventListener('scroll', function () { if (offen) oben(); }, { passive: true });
    // Über die Grenze 1024 px hinweg schließen (Rechner- und Handy-Ausklapper sind verschieden gestaltet)
    var warDesktop = MQ.matches;
    window.addEventListener('resize', function () { if (MQ.matches !== warDesktop) { warDesktop = MQ.matches; zu(false); } else if (offen) oben(); });

    // Spalte 1 schaltet Auswahl und Bild um; beim Schließen wieder auf den ersten Bereich
    Object.keys(panels).forEach(function (k) {
      var p = panels[k];
      var tabs = Array.prototype.slice.call(p.querySelectorAll('[data-zd-tab]'));
      if (!tabs.length) return;
      var inhalte = p.querySelectorAll('[data-zd-tabinhalt]');
      var erster = tabs[0].getAttribute('data-zd-tab');
      var tabWahl = function (name) {
        tabs.forEach(function (t) { t.classList.toggle('is-aktiv', t.getAttribute('data-zd-tab') === name); });
        inhalte.forEach(function (c) { c.hidden = c.getAttribute('data-zd-tabinhalt') !== name; });
        bilder(p);
      };
      tabs.forEach(function (t) {
        var name = t.getAttribute('data-zd-tab');
        t.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') tabWahl(name); });
        t.addEventListener('focus', function () { tabWahl(name); });
        if (t.tagName === 'BUTTON') t.addEventListener('click', function () { tabWahl(name); });
      });
      new MutationObserver(function () { if (p.hidden) tabWahl(erster); }).observe(p, { attributes: true, attributeFilter: ['hidden'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
